<template>
  <div class="government-enterprise">
    <Header />
    <div class="container mx-auto px-4 pt-24 pb-16">
      <h1 class="text-4xl font-bold mb-8 text-center">政企解决方案 - 助力数字化转型与智能升级</h1>
      
      <div class="bg-white rounded-lg shadow-lg p-8 mb-8">
        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4 text-blue-600">数字化转型的全方位解决方案</h2>
          <p class="text-gray-700 mb-4">
            面对数字经济时代的挑战与机遇，chmura云通讯为政企客户提供了全方位的数字化转型解决方案。我们的产品和服务涵盖云计算、大数据、物联网、安全、AI等领域，帮助政府和企业实现业务创新、效率提升和成本优化。
          </p>
          <p class="text-gray-700 mb-4">
            截至2025年，chmura云通讯已服务超过200家政企客户，覆盖政府、金融、医疗、教育、制造、能源等多个行业。我们的解决方案在数字化转型成功率、投资回报率和客户满意度等方面均处于行业领先地位。
          </p>
        </div>

        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4 text-blue-600">核心解决方案体系</h2>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="bg-blue-50 rounded-lg p-6">
              <h3 class="font-semibold text-lg mb-3">政企云平台</h3>
              <p class="text-gray-700">提供私有云、公有云、混合云等多种部署方式，满足不同规模企业的云计算需求，实现资源的高效利用。</p>
            </div>
            <div class="bg-blue-50 rounded-lg p-6">
              <h3 class="font-semibold text-lg mb-3">大数据分析平台</h3>
              <p class="text-gray-700">基于AI的数据分析工具，帮助企业挖掘数据价值，实现智能化决策和精准营销。</p>
            </div>
            <div class="bg-blue-50 rounded-lg p-6">
              <h3 class="font-semibold text-lg mb-3">物联网解决方案</h3>
              <p class="text-gray-700">支持海量设备连接和数据采集，为工业4.0、智慧城市等应用场景提供端到端解决方案。</p>
            </div>
            <div class="bg-blue-50 rounded-lg p-6">
              <h3 class="font-semibold text-lg mb-3">信息安全体系</h3>
              <p class="text-gray-700">全方位的安全防护方案，包括网络安全、数据安全、终端安全等，保障企业数字化转型的安全稳定。</p>
            </div>
          </div>
        </div>

        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4 text-blue-600">行业应用案例</h2>
          <p class="text-gray-700 mb-4">
            在政府领域，chmura云通讯为政府搭建了智慧城市平台，实现了城市管理的数字化、智能化。该平台集成了交通、环保、安防等多个领域的数据，通过AI分析实现了交通拥堵治理、环境污染监测等功能，城市治理效率提升了60%。
          </p>
          <p class="text-gray-700">
            在制造行业，我们为某大型汽车制造商提供了工业互联网解决方案，实现了生产过程的实时监控和优化。通过物联网传感器和大数据分析，该企业的生产效率提升了35%，产品合格率提高了20%。
          </p>
        </div>

        <div class="mb-8">
          <h2 class="text-2xl font-bold mb-4 text-blue-600">服务优势</h2>
          <p class="text-gray-700 mb-4">
            chmura云通讯拥有一支专业的技术服务团队，提供7×24小时的技术支持和运维服务。我们的服务覆盖方案设计、实施、运维等全生命周期，确保客户的数字化转型项目顺利推进。
          </p>
          <p class="text-gray-700">
            同时，我们建立了完善的合作伙伴生态系统，与国内外知名企业和研究机构开展深度合作，共同推动政企数字化转型的发展。
          </p>
        </div>

        <div class="text-center">
          <el-button type="primary" size="large" @click="$router.push('/contact')" class="bg-blue-600 hover:bg-blue-700">
            联系我们了解更多
          </el-button>
        </div>
      </div>
    </div>
    <Footer />
    <BackToTop />
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import BackToTop from '../components/BackToTop.vue'

export default {
  name: 'GovernmentEnterprise',
  components: {
    Header,
    Footer,
    BackToTop
  }
}
</script>

<style scoped>
.government-enterprise {
  padding-top: 80px;
}
</style>
